'use strict'

const _config = {
  // BASE_URL: '/web-dev/ipo/',
  BASE_URL: '/ipo/',
  API_KEY: process.env.IPO_API_KEY
}
module.exports = _config



// WEBPACK FOOTER //
// ./src/_config.js